
    $(document).ready(function(){
        removeInsurance();
        if (localStorage.getItem('insuranceAutoOn') == null) {
          localStorage.setItem('insuranceAutoOn', 'true');
        }
      
          const defaults = {
              cartDrawerTrigger: '.js-cart-trigger', // classname
              addToCart: '.add-cart-btn', // classname
              removeFromCart: '.js-ajax-remove-from-cart', //classname
              checkoutButton: '.ajax-cart-checkout'
          };
      
            $("body").on("click",".ajax-cart-checkout, button[name='checkout']", function(e){
            $(this).prop('disabled', true);
            e.preventDefault();
            localStorage.removeItem("insuranceAutoOn");
              let is_insurance_present = $(".js-shipping-insurance-switch").is(":checked");
              if(is_insurance_present){
                    calculateInsurance();
                }else{
                    location.href = "/checkout";
                }
          });
          function calculateInsurance(){
            var shippingInsurance;
            var subsCart;
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                async:false,
                success: function(cart) {
                    try {
                        if (cart.total_price < 5000) {
                            shippingInsurance = 43132000502009;
                        } else if (cart.total_price >= 5000 && cart.total_price < 10000) {
                            shippingInsurance = 43132000534777;
                        }else if( cart.total_price >= 10000 && cart.total_price < 20000 ){
                            shippingInsurance = 43132000567545;
                        }else if( cart.total_price >= 20000){
                            shippingInsurance = 43193992380665;
                        }
    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: { id : shippingInsurance, quantity: 1},
                        async: false,
                        success: function() {
                          console.log('Insurance added successfuly');
                        },
                        error: function(){
                            console.log('error');
                        }
                      });
                    } catch (error) {
                        console.error(error);
                    } 
                }
            });
              location.href = "/checkout";
          }
    
      });
      var itemsCount;
      var minVal, maxVal, btnText, selectedQty;
      var SHIPPING_INSURANCE_PRICE = 1.95;
        
        function removeItemFromCart(lineIndex){
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=' + 0 + '&line=' + lineIndex,
                dataType: 'json',
                    async:false,
                success: function(cart) {
                    itemsCount = cart.item_count;
                    location.reload(true);
                    localStorage.setItem('insuranceAutoOn', 'true');

                }
            });
        }

        function removeInsurance(){
            $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                async:false,
                success: function(cart) {
                    for(let i = 0; i < cart.items.length; i++)
                    {
                        if(cart.items[i].id === 43132000502009 || cart.items[i].id === 43132000534777 || cart.items[i].id === 43132000567545 || cart.items[i].id ===  43193992380665)
                        {
                            removeItemFromCart(i+1);
                        }  
                    }
                }
            });
        }